<template>
  <!--  {{ routeData }} -->
  <div class="success_box">
    <div class="inners">
      <div class="right">
        <div>
          <el-icon style="color:#72c140;font-size: 58px">
            <SuccessFilled/>
          </el-icon>
        </div>
        <div class="inner_text">
          <span class="text" v-if="routeData.groupType">
            {{ $t('group.send.task.submit') }}
          </span>

          <!-- 解决 texts 翻译不出来：使用 transText -->
          <span class="text" v-else>{{ $t('common.email') }}{{ transText }}!</span>

          <!-- 成功发送邮件 -->
          <span v-if="!isSaveSuccess" style="margin-top: 8px">
            {{ $t('common.yjbcz') }}
            <el-button link type="primary" @click="toSend">
              {{
                texts === i18n.global.t('sys.message.success')
                    ? `「${$t('common.draftsbox')}」`
                    : routeData.groupType
                        ? `「${$t('group.send.task.list')}」`
                        : `「${$t('common.has.sent')}」`
              }}
            </el-button>
          </span>
          <!-- 保存成功 -->
          <span v-if="isSaveSuccess" style="margin-top: 8px">
            {{ $t('common.yjbcz') }}
            <el-button link type="primary" @click="toDraf">「{{ $t('common.draftsbox') }}」</el-button>
          </span>

          <span style="margin-top: 17px">
            <span style="vertical-align: sub;"><img src="@/assets/write.png" width="16" height="16" alt=""/></span>
            <el-button link type="primary" @click="requestAgain">
              {{ $t('common.team.toWriteLetter') }}
            </el-button>
          </span>
        </div>
        <!-- 邮件客户区域 -->
        <div class="area_box" v-loading="isArchiveBoxLoading"
             v-if="isSendSuccessOk && newEmailArray.length>0">
          <!--          && routeData.isNoArchive*1!==1-->
          <div>
            <span style="line-height: 30px;">{{ $t('group.send.belong.customer') }}</span>
            <div class="left">
              <!--              <div-->
              <!--                  style="text-align: center;line-height: 28px;display: flex;align-items:center;justify-content:space-between"-->
              <!--                  v-for="item in newEmailArray"-->
              <!--                  :key="item.email">-->
              <!--                <el-popover-->
              <!--                    :content="item.email"-->
              <!--                    :width="'max-content'"-->
              <!--                    trigger="hover"-->
              <!--                    :popper-style="{ minWidth: '60px', width: 'auto' }"-->
              <!--                    effect="dark"-->
              <!--                    placement="left"-->
              <!--                    :show-after="1200"-->
              <!--                >-->
              <!--                  <template #reference>-->
              <!--                   <span-->
              <!--                       style="display: inline-block;max-width:300px;width:auto;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;text-align: right">-->
              <!--                    {{ item.email }}-->
              <!--                   </span>-->
              <!--                  </template>-->
              <!--                </el-popover>-->
              <!--                <el-button-->
              <!--                    style="margin-left: 10px !important;min-width: 100px;display: flex;justify-content: flex-start;"-->
              <!--                    link-->
              <!--                    type="primary"-->
              <!--                    @click="addTargetCustomer(item.email)">-->
              <!--                  {{ $t('common.archives.return') }}-->
              <!--                </el-button>-->
              <!--              </div>-->
              <el-table
                  :data="newEmailArray"
                  style="width: 100%;background: red"
                  :border="false"
                  :show-header="false"
                  size="small"
                  class="plain-table-zq-ap"
              >
                <!-- 邮箱列 -->
                <el-table-column
                    prop="email"
                    label="Email"
                    align="right"
                    width="240"
                    :show-overflow-tooltip="true"
                >
                  <template #default="{ row }">
                    <span style="font-size: 14px !important;">{{ row.email }}</span>
                  </template>
                </el-table-column>

                <!-- 操作列 -->
                <el-table-column
                    label="操作"
                    width="150"
                    align="left"
                >
                  <template #default="{ row }">
                    <el-button
                        link
                        type="primary"
                        @click="addTargetCustomer(row.email)"
                    >
                      {{ $t('common.archives.return') }}
                    </el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- 对话框 -->
  <ReturnEmails
      ref="emailsReturn"
      v-if="dialogVisible"
      v-model="dialogVisible"
      @close="close"
      @createCustomer="createdNewCustomer"
      :targetEmail="newEmailArray"
      :targetEmailData="targetEmailData"
  />
  <CustomerCreated
      ref="customerCreated"
      v-if="dialogVisibleCreatedMessage"
      v-model="dialogVisibleCreatedMessage"
      @close="closeCreated"
      :innerDialog="dialogVisible"
      @changeInnerDialog="close"
  />
</template>

<script setup>
import {useRoute, useRouter} from "vue-router";
import {ref, onMounted, nextTick, computed, getCurrentInstance} from "vue";
import {Base64} from "js-base64";
import {useStore} from "vuex";
import ReturnEmails from "@/components/DiaPops/Returns/ReturnEmails.vue";
import CustomerCreated from "@/components/DiaPops/Returns/CustomerCreated.vue";
import {i18n} from "../../lang";
import {getUnArchiveApi} from "@/api";
import {ElMessage} from "element-plus";

const store = useStore()
const router = useRouter();
const route = useRoute()

const dialogVisible = ref(false)
const dialogVisibleCreatedMessage = ref(false)
const emailsReturn = ref(null)
const teamId = computed(() => store.state.email.teamID)
// 取全局翻译函数
const {appContext} = getCurrentInstance()
const $t = appContext.config.globalProperties.$t.bind(appContext.config.globalProperties)

// texts 原始值（可能是 key，也可能是已翻译的文字）
const texts = ref('')
const routeData = ref({})

// 解决：texts 翻译不成功 → 统一通过 computed 翻译
const transText = computed(() => {
  if (!texts.value) return '';
  try {
    return $t(texts.value);
  } catch {
    return texts.value;
  }
});

// 标准判断（兼容 texts 是 key 或翻译文本）
const isSendSuccessOk = computed(() => {
  const key = 'common.email.list.sendSuccessOk';
  const key2 = 'sys.message.success'
  return (texts.value === key || $t(texts.value) === $t(key)) || (texts.value === key2 || $t(texts.value) === $t(key2));
});

const isSaveSuccess = computed(() => {
  const key = 'sys.message.success.save';
  // 保存到草稿箱 || 定时发送
  return (texts.value === key || $t(texts.value) === $t(key)) || routeData.value.sendTime;
});

onMounted(async () => {
  try {
    const q = route.query.q;
    if (q) {
      const decoded = JSON.parse(Base64.decode(q));
      routeData.value = decoded;
      texts.value = decoded?.text || '';

      //   获取未建档的邮箱
      await getUnArchive()
    }
  } catch (e) {
    console.error("decode error:", e);
  }
});


const isArchiveBoxLoading = ref(false)
const newEmailArray = ref([])
// 获取未建档的邮箱
const getUnArchive = async () => {
  const payload = {
    teamId: teamId.value,
    emailList: routeData.value.emailArray.map(_ => _.email)
  }
  isArchiveBoxLoading.value = true
  const res = await getUnArchiveApi(payload)
  if (res.code !== 200) {
    isArchiveBoxLoading.value = false
    ElMessage.error(i18n.global.t('common.failed.send'))
    return
  }
  isArchiveBoxLoading.value = false
  newEmailArray.value = res.result.map(_ => ({email: _}))
}
// 重新写邮件
const requestAgain = () => {
  const q = route.query.q;
  if (!q) return;
  let decoded = JSON.parse(Base64.decode(q));

  if (decoded.groupType) {
    router.push({
      path: '/email/send_all',
      query: {
        massTaskId: decoded.massTaskId,
        customerId: decoded.customerId,
        type: decoded.groupType === "1" ? 1 : 2,
        flag: 'again',
      }
    })
  } else {
    router.push({
      path: '/email/write_mail',
      query: {
        id: decoded.emailId,
        type: "resend",
        customerId: decoded.customerId,
        flag: 'again'
      }
    })
  }
};

// 跳转查看发送结果
const toSend = () => {
  const q = route.query.q;
  if (!q) return;
  const decoded = JSON.parse(Base64.decode(q));

  if (decoded.groupType) router.push('/email/customer/sending');
  else if (decoded.text === i18n.global.t('sys.message.success')) router.push("/email/draft");
  else router.push('/email/has_send');
};

const toDraf = () => router.push('/email/draft');

// 添加目标客户
const targetEmailData = ref('')
const addTargetCustomer = async (email) => {
  dialogVisible.value = true;
  await nextTick();
  targetEmailData.value = email
  emailsReturn.value.getAllCustomers();
};

const close = () => dialogVisible.value = false;
const closeCreated = () => dialogVisibleCreatedMessage.value = false;

// 创建新客户
const createdNewCustomer = async () => {
  dialogVisibleCreatedMessage.value = true;
  await store.commit('customer/setRuleForm', {
    zoneCode: "",
    customerCode: "",
    zoneAddress: "",
    customerName: "",
    setUpTime: "",
    economicNature: "",
    companyWebsite: "",
    companyAddress: "",
    phoneWayList: [],
    emailWayList: [],
    companyFax: "",
    companyRemark: "",
    customerLevel: "",
    customerType: "",
    customerTypeId: "",
    product: "",
    marketingRemark: " ",
    createBy: "",
    branchAdmin: "",
    mangerVOList: [{managerName: ''}]
  });
  await store.commit('customer/setForm', {
    phones: [{phoneNumber: "", isDefault: true}],
    emails: [{email: "", isDefault: true}],
  });
};
</script>

<style lang="less" scoped>
@import "../Customer/less/detail.less";
@import "../components/EmailList/index.less";

.flex {
  display: flex;
  justify-content: center;
  align-items: center;
}

.success_box {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: column;
  background: #f5f5f5;
  height: calc(100vh - 48px);
  padding-top: 47px;

  .text {
    height: 32px;
    font-size: 24px;
    font-weight: 500;
    color: rgba(0, 0, 0, 0.85);
    line-height: 32px;
  }

  .inner_text {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    font-size: 14px;
    color: rgba(0, 0, 0, 0.45);

    a {
      color: #1890FF;
    }
  }

  .area_box {
    width: 575px;
    background: #EAF3FB;
    margin-top: 28px;
    font-size: 14px;
    display: flex;
    align-items: center;
    justify-content: center;

    > div {
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 16px 20px;
    }
  }
}

.inners {
  width: 1000px;
  background: white;
  padding-top: 58px;

  .right {
    padding-bottom: 40px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
}

:deep(.el-button) {
  & > span {
    font-size: 14px !important;
  }
}

:deep(.el-form-item__label) {
  font-weight: normal !important;
  font-size: 13px !important;
  color: #000 !important;
}

:deep(.el-select__wrapper) {
  font-size: 13px !important;
}

:deep(.el-select__placeholder) {
  font-size: 13px !important;
}
</style>